// Real pages from NATURKLAR™ Bind 1 (Gamma Studio), WebP 1080x1350 in Impultienda Recursos (store NATURKLAR aafcac3c-...).
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/aafcac3c-d8a9-4b15-ae3e-6e58e87facfd/';
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [{
  src: BASE + '1792695379301_nk-bind1-side01-95d5d607.webp',
  label: 'Bind 1 · Forside',
  title: 'Årsplan + 12 lektioner minut for minut',
  text: 'Årsplaner for 1.–2., 3.–4. og 5.–6. klasse, bygget på Fælles Mål – samlet i ét bind.'
}, {
  src: BASE + '1792695383237_nk-bind1-side14-69988f0a.webp',
  label: 'Bind 1 · Side 14',
  title: 'Lektion 2 · Flyder eller synker? (1. klasse)',
  text: 'Færdig lektion på 45 minutter: mål, materialer, sikkerhed, minut for minut og lærerens instruktion.'
}, {
  src: BASE + '1792695387400_nk-bind1-side25-078ce76f.webp',
  label: 'Bind 1 · Side 25',
  title: 'Elevark · Lektion 7: Fødekæder i skoven',
  text: 'Samme mål i 3 niveauer – støtte, basis og udfordring – med facit til læreren.'
}, {
  src: BASE + '1792695391299_nk-bind1-side28-bf193459.webp',
  label: 'Bind 1 · Side 28',
  title: 'Lektion 9 · Byg en simpel strømkreds (5. klasse)',
  text: 'Undersøgelse og kommunikation i praksis: åben og lukket kreds, materialeliste og sikkerhedsregler.'
}, {
  src: BASE + '1792695395616_nk-bind1-side38-deb16888.webp',
  label: 'Bind 1 · Side 38',
  title: 'Facit til testene (lærerens eksemplar)',
  text: 'Tests for 1.–3. og 4.–6. klasse med færdigt facit og en enkel skala, så rettearbejdet går hurtigt.'
}];
